import { RESPONSE_COMPONENT_FULL_BLOCKS } from '../responseComponentDemoData'
import { scaleChatStreamDelay } from '../streaming/chatStreamSpeed.js'
import { updatePendingDemoMessage } from './patchResponseComponentDemoMessage.js'

/** @param {import('./runResponseComponentDemoStream.js').DemoStreamCtx} ctx */
export function startResponseComponentDemoStreamLoop(ctx) {
  const { tid, pendingId, signal, session, setMessagesByThreadId } = ctx
  let blockIdx = 0
  let charIdx = 0
  /** @type {unknown[]} */
  const currentBlocks = []

  const streamNext = () => {
    if (signal.aborted || blockIdx >= RESPONSE_COMPONENT_FULL_BLOCKS.length) {
      session.dispose()
      return
    }
    const block = RESPONSE_COMPONENT_FULL_BLOCKS[blockIdx]
    if (typeof block.content === 'string') {
      const typeChar = () => {
        if (signal.aborted) {
          session.dispose()
          return
        }
        charIdx++
        updatePendingDemoMessage(setMessagesByThreadId, tid, pendingId, [
          ...currentBlocks,
          { ...block, content: block.content.slice(0, charIdx) },
        ])
        if (charIdx < block.content.length) session.addTimeout(typeChar, scaleChatStreamDelay(10))
        else {
          currentBlocks.push(block)
          blockIdx++
          charIdx = 0
          session.addTimeout(streamNext, scaleChatStreamDelay(200))
        }
      }
      typeChar()
    } else {
      currentBlocks.push(block)
      updatePendingDemoMessage(setMessagesByThreadId, tid, pendingId, [...currentBlocks])
      blockIdx++
      session.addTimeout(streamNext, scaleChatStreamDelay(300))
    }
  }

  session.addTimeout(streamNext, scaleChatStreamDelay(500))
}
